import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";
import { api } from "@/lib/api";

export default function BillingReturn() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [state, setState] = useState("working"); // working | ok | fail

  useEffect(() => {
    const returnTo = localStorage.getItem("om_billing_return") || "/dashboard/billing";
    const session = params.get("session");
    const cancelled = params.get("cancelled");
    if (cancelled || !session) {
      setState("fail");
      setTimeout(() => navigate(returnTo), 1800);
      return;
    }
    api.post("/billing/verify-status", { session_id: session })
      .then((r) => {
        setState(r.data.verified ? "ok" : "fail");
        setTimeout(() => navigate(returnTo + (r.data.verified ? "?billing=verified" : "?billing=failed")), 1600);
      })
      .catch(() => { setState("fail"); setTimeout(() => navigate(returnTo), 1800); });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-6" data-testid="billing-return">
      <div className="rounded-2xl border border-slate-200 bg-white p-10 text-center max-w-sm">
        {state === "working" && <><Loader2 className="h-10 w-10 animate-spin text-blue-600 mx-auto" /><p className="mt-4 font-semibold text-slate-900">Confirming your payment…</p></>}
        {state === "ok" && <><CheckCircle2 className="h-12 w-12 text-emerald-500 mx-auto" /><p className="mt-4 font-semibold text-slate-900">Payment method verified</p><p className="text-sm text-slate-500 mt-1">Taking you back…</p></>}
        {state === "fail" && <><XCircle className="h-12 w-12 text-red-500 mx-auto" /><p className="mt-4 font-semibold text-slate-900">Verification not completed</p><p className="text-sm text-slate-500 mt-1">Please try again.</p></>}
      </div>
    </div>
  );
}
